import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../lib/i18next";
import { REGENERATING_AD_TEXTS_OVERLAY_MESSAGE } from "../../i18n/keysTranslations";

const AdPreviewRegeneratingTextsOverlay = ({ open }) => {
  const { t } = useTranslationApp();

  if (!open) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        bgcolor: "rgba(255, 255, 255, 0.82)",
        borderRadius: 1,
        pointerEvents: "auto",
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.primary" textAlign="center">
        {t(REGENERATING_AD_TEXTS_OVERLAY_MESSAGE)}
      </Typography>
    </Box>
  );
};

export default AdPreviewRegeneratingTextsOverlay;
